import React, { useContext, useEffect, useMemo, useState } from 'react';
import pt from 'prop-types';
import { navigate } from 'gatsby';

import * as styles from './anchorLinkNavigation.module.scss';
import Link from '../../components/ui/link';
import Text from '../../components/ui/text';
import Dropdown from '../../components/ui/dropdown';
import Container from '../container';
import { getCopy } from '../../helpers/copy';
import { MicrocopyContext } from '../../context/microcopy.context';

const AnchorLinkNavigation = ({ items }) => {
  const microcopy = useContext(MicrocopyContext);
  const [path, setPath] = useState('');

  useEffect(() => {
    setPath(window.location.pathname);
  }, []);

  const options = useMemo(
    () => [
      {
        label: getCopy('anchorNavigation.placeholder', microcopy),
        value: false,
        disabled: true,
      },
      ...items.map((item) => ({
        label: item.label,
        value: item.anchorId,
      })),
    ],
    [items]
  );

  const onItemClick = (event) => navigate(`#${event.target.value}`);

  return (
    <div className={styles.anchorLinkNavigation}>
      <Container fluid>
        <Dropdown
          name="language"
          defaultValue={options[0].value}
          options={options}
          onSelect={onItemClick}
          withoutLabel
          className={styles.mobileOnly}
        />
        <div className={styles.tabletOrBigger}>
          {items.map((item) => (
            <Link
              link={{ linkToPage: path, anchor: item.anchorId }}
              key={item.anchorId}
              className={styles.anchorLink}
            >
              <Text as="span" type="button">
                {item.label}
              </Text>
            </Link>
          ))}
        </div>
      </Container>
    </div>
  );
};

AnchorLinkNavigation.propTypes = {
  items: pt.arrayOf(
    pt.shape({
      label: pt.string,
      anchorId: pt.string,
    })
  ).isRequired,
};

AnchorLinkNavigation.defaultProps = {
  items: [],
};

export default AnchorLinkNavigation;
